import { PaymentSidePanelViewModel } from "../../../shared/paymentDialog/PaymentSidePanelViewModel";

export class ArticleBuySectionViewModel {
  readonly type = "BUY";

  constructor(public paymentSidePanelViewModel: PaymentSidePanelViewModel) {}
}
